import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover'
var classNames = require('classnames')

export const AdditionalPopover = (props) => {
  return (
    <SkyInformationPopover eventId={'additional-insured'}>
      <div className="text-body bold">
        The following entities cannot be listed as additional insured:
      </div>
      <div className="text-small margin-top-small">
        - UAS repair shops, UAS parts supplier etc.
      </div>
      <div className="text-small margin-top-small">
        - Entities providing any UAS service such as flight planning, software
        service etc.
      </div>
      <div className="text-small margin-top-small">
        - UAS sales organization and manufacturers
      </div>
      <div className="text-small margin-top-small">
        - Any party having an association with an airshow
      </div>
      <div className="text-small margin-top-small">
        - Any insurance broker, arranger or another insurance company unless the
        name insured is providing drone services and operations to them as a
        client
      </div>
    </SkyInformationPopover>
  )
}
